/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class OwnershipProxyGrid extends SiteEntityGrid<OwnershipProxyRow, any> {
        protected getColumnsKey() { return 'Data.OwnershipProxy'; }
        protected getDialogType() { return OwnershipProxyDialog; }
        protected getIdProperty() { return OwnershipProxyRow.idProperty; }
        protected getLocalTextPrefix() { return OwnershipProxyRow.localTextPrefix; }
        protected getService() { return OwnershipProxyService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}